import httpUtils from '../../utils/HttpUtils'
import session from "../../../../supervisor-h5/src/utils/Session";

class EvaluateService {

  async evaluateList (supervisorId = '', companyId = '', projectId = '', type = '', isSupervisorReq = '') {
    let result = null;
    try {
      if(companyId != null){
        result = await httpUtils.post('/server/evaluate/list',{ supervisorId, companyId, projectId, type ,isSupervisorReq});
      }else {
        result = await httpUtils.post('/server/evaluate/list',{ supervisorId, projectId, type , isSupervisorReq});
      }
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //用户评价
  async evaluatePost (supervisorId='',projectId='',score='',content='',companyId='') {
    console.log('用户评价');
    var result = null;
    try {
      result = await httpUtils.post('/server/evaluate/post',{supervisorId,projectId,score,content,companyId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  async getCompanyEvaluate (companyId='') {
    let result = null;
    try {
        result = await httpUtils.post('/server/evaluate/avg',{companyId})
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  async detail (id = '') {
    let result = null;
    try {
      result = await httpUtils.post('/server/evaluate/detail',{ id });
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  async update (id = '', score = '', content = '') {
    let result = null;
    try {
      result = await httpUtils.post('/server/evaluate/post',{ id, score, content });
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new EvaluateService()
